module.exports = __webpack_public_path__ + "assets/img/button-report.115c6702.png";